import * as v from 'valibot';
import Ajax from '../util/ajax';
import { macroAdded } from '../features/macros/macrosSlice';
import { hideDialog } from '../reducers/app';
import { macroSchema } from '../types/Macro';
export function createMacro() {
    return (dispatch, getState) => {
        const { edit_macro_dialog } = getState();
        const ajax = new Ajax(dispatch);
        const url = '/macro/create';
        const obj = {
            title: edit_macro_dialog.title,
            active: edit_macro_dialog.active,
            // for some reason the macro items are called commands when we post to the backend, we should fix the backend
            commands: JSON.stringify(edit_macro_dialog.items),
        };
        ajax.post(url, obj, data => {
            const res = v.safeParse(macroSchema, data);
            if (res.success) {
                dispatch(macroAdded(res.output));
            }
            else {
                console.error(v.summarize(res.issues));
            }
            dispatch(hideDialog());
        });
    };
}
